import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import TaskEstimateRowContextProvider from '~/modules/tasks/components/TaskDrawer/TaskResourceEstimates/TaskEstimateRowContextProvider';
import RemoveTaskAllocationDialog from '~/modules/tasks/components/TaskDrawer/TaskResourceEstimates/components/RemoveTaskAllocationDialog';
import { updateTaskResourceAllocationCacheOnRemove } from '~/modules/resourcing/common/hooks';
import { useTaskEstimateRowContextDataBuilder } from '~/modules/tasks/components/TaskDrawer/TaskResourceEstimates/hooks';

import useOnRemoveTaskAllocationSuccess from './hooks/useOnRemoveTaskAllocationSuccess';

export const RemoveTaskAllocationConfirmationDialog = ({
  projectId,
  task,
  user,
  open,
  onClose,
  openRemoveTaskAssignmentDialog,
  refetchQueries,
  handleRemoveResourceAllocation
}) => {
  const {
    loading,
    taskDetail,
    taskResourceEstimate
  } = useTaskEstimateRowContextDataBuilder({ projectId, task, user });

  const { onRemoveTaskAllocationSuccess } = useOnRemoveTaskAllocationSuccess({
    onClose,
    handleRemoveResourceAllocation,
    userId: user.id
  });

  const dialogProps = useMemo(
    () => ({
      openRemoveEstimateDialog: openRemoveTaskAssignmentDialog
    }),
    [openRemoveTaskAssignmentDialog]
  );

  return (
    <TaskEstimateRowContextProvider
      task={taskDetail}
      resourceEstimate={taskResourceEstimate}
      canEditTasks={false}
      dialogProps={dialogProps}
    >
      <RemoveTaskAllocationDialog
        isLoading={loading}
        open={open}
        onClose={onClose}
        onRemoveTaskAllocationSuccess={onRemoveTaskAllocationSuccess}
        updateCache={updateTaskResourceAllocationCacheOnRemove({
          userId: user.id,
          projectId,
          taskUris: [task.id]
        })}
        refetchQueries={refetchQueries}
      />
    </TaskEstimateRowContextProvider>
  );
};

RemoveTaskAllocationConfirmationDialog.propTypes = {
  projectId: PropTypes.string.isRequired,
  task: PropTypes.object,
  user: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  openRemoveTaskAssignmentDialog: PropTypes.func.isRequired,
  refetchQueries: PropTypes.array,
  handleRemoveResourceAllocation: PropTypes.func.isRequired
};
